import {
  call,
  put,
  select
} from 'redux-saga/effects';
import {
  actions as custoActions
} from '@/reducers/custo-reducer';

function* getCustomParamsWhenActivity(context) {
  try {
    const commonModule = yield call(() =>
      import('@gerenciatd/next.utils.common')
    );
    const urlParams = commonModule.getUrlParams({
      groupByObject: true,
      allowedParams: [
        /recomEnterprise/g,
        /percentile/g,
        /levCode/g,
        /prodCode/g,
        /promoCode/g,
        /ctz_c/g,
        /turingDev/g,
        /productOffering/g,
        /webCode/g,
        /context.*/g,
        /custoHost/g,
        /businessClusters/g,
        /recomType/g,
        /userType/g,
        /custoLegacy/g,
        /ctzTest/g,
      ],
    });
    const {
      clientIDs,
      pageSegment,
      userCUCFijoHash,
      userCUCMovilHash,
      userIdPartyHash,
    } = context;

    const custoObject = {
      i3_cuc: userCUCFijoHash || '',
      i3_cucm: userCUCMovilHash || '',
      i3_idp: userIdPartyHash || 'default',
      data: {
        SEG_NAV: pageSegment,
        ga: clientIDs.ga,
        originUrl: window.location.href,
      },
      urlParams,
    };

    return custoObject;
  } catch (e) {
    throw new Error(e);
  }
}

let tabOpen = false;
export function* getCreativity({
  data
}) {
  const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
  const {
    creativityId,
    build
  } = data;
  try {
    let {
      kind
    } = data;
    if (!kind) {
      kind = 'creativity';
    }
    let custoParams = {};
    let preRenderEnv = null;
    let getByName = yield call(() => import('./get-by-name'));
    getByName = getByName.default;
    const context = yield select((state) => state.main.context);


    if (currentEnv === 'qa' && build) {
      return null
    } 

    if (!build) {
      custoParams = yield call(getCustomParamsWhenActivity, context);
    } else {
      preRenderEnv = 'movistar.es';
    }

    let response = null;
    response = yield call(getByName, {
      context,
      build,
      preRenderEnv,
      name: creativityId,
      custoParams,
      kind,
    });

    if (response && typeof response === 'string') {
      response = JSON.parse(response);
    }

    yield put(
      custoActions.setCreativity({
        creativityId,
        info: response,
      })
    );
    
  } catch (err) {
    console.error(`[get-by-name]: ${err}`);
  }
}

export default getCreativity;
